unit OrderConfirmation;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, Vcl.Controls,
  Vcl.StdCtrls, WEBLib.StdCtrls, VCL.TMSFNCTrackBar, VCL.TMSFNCSpinEdit,
  VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, WEBLib.ExtCtrls,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCDataGridDatabaseAdapter, Data.DB,
  WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  VCL.TMSFNCBitmapContainer, WEBLib.DBCtrls, VCL.TMSFNCButton;

type
  TfrmOrderConfirmation = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    pnlJobcards: TPanel;
    pnlPurchaseOrders: TPanel;
    dgJobCards: TTMSFNCDataGrid;
    WebPanel4: TPanel;
    dgPurchaseOrders: TTMSFNCDataGrid;
    wcJobcards: TXDataWebClient;
    wdsJobCards: TXDataWebDataSet;
    dsJobcards: TDataSource;
    dgdbaJobcards: TTMSFNCDataGridDatabaseAdapter;
    wdsJobCardsJOBCARDNO: TStringField;
    wdsJobCardsTRUCKREGNO: TStringField;
    wdsJobCardsJobcardType: TStringField;
    wdsJobCardsTOTALCOSTEXCL: TFloatField;
    wcPurchaseorder: TXDataWebClient;
    wdsPurchaseOrder: TXDataWebDataSet;
    dsPurchaseOrder: TDataSource;
    dgdbaPurchaseorder: TTMSFNCDataGridDatabaseAdapter;
    wdsPurchaseOrderORDERNO: TStringField;
    wdsPurchaseOrderTOTALCOSTEXCL: TFloatField;
    wdsPurchaseOrderSupplier: TStringField;
    wdsPurchaseOrderORDERDATE: TStringField;
    wdsPurchaseOrderapproved: TStringField;
    BitmapContainer1: TTMSFNCBitmapContainer;
    WebTimer1: TTimer;
    btnPrevMonth: TTMSFNCButton;
    wlMonth: TDBLabel;
    btnNextMonth: TTMSFNCButton;
    wdsJobCardsUserMax: TIntegerField;
    wdsJobCardsMBudget: TIntegerField;
    wdsJobCardsJobcardDate: TDateTimeField;
    wcAvailBudget: TXDataWebClient;
    dsAvailBudget: TDataSource;
    wdsAvailBudget: TXDataWebDataSet;
    wdsAvailBudgetAvailableBudget: TFloatField;
    procedure WebButton1Click(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure dgJobCardsCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebFormResize(Sender: TObject);
    procedure dgPurchaseOrdersGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgPurchaseOrdersCellClick(Sender: TObject; AColumn,
      ARow: Integer);
    procedure dgPurchaseOrdersGetCellLayout(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure WebTimer1Timer(Sender: TObject);
    procedure dgPurchaseOrdersGetCellDisplayValue(Sender: TObject;
      ACell: TTMSFNCDataGridCellCoord; AData: TTMSFNCDataGridCellValue;
      var AValue: string);
    procedure btnPrevMonthClick(Sender: TObject);
    procedure btnNextMonthClick(Sender: TObject);


  private
    { Private declarations }
    wYear,
    wMonth,
    wDay : Word;
    sJobCardNo : String;
    TJobDate : TDate;
    procedure UpdateDateLabel;
    procedure LoadJobcards;
    procedure LoadPurchOrders;
    Procedure GetBudget;

    procedure ApproveOrder(sOrderNo , sApprove: String);
    procedure CancelOrder(sOrderNo : String);
  public
    { Public declarations }

  protected procedure LoadDFMValues; override; end;

var
  frmOrderConfirmation: TfrmOrderConfirmation;

implementation

{$R *.dfm}

uses
  stfmssystem.connection, share.common, share.classes;

procedure TfrmOrderConfirmation.dgPurchaseOrdersCellClick(Sender: TObject;
  AColumn, ARow: Integer);
begin

  dgdbaPurchaseorder.SetActiveRecord(ARow);

  if AColumn = 5 then
    Begin
      if dgdbaPurchaseorder.FieldAtColumn[4].AsString = 'N' then
        begin
          ApproveOrder(dgdbaPurchaseorder.FieldAtColumn[0].AsString,'Y');
        end;
    End;

  if AColumn = 6 then
    Begin
      if dgdbaPurchaseorder.FieldAtColumn[4].AsString = 'N' then
        begin
          ApproveOrder(dgdbaPurchaseorder.FieldAtColumn[0].AsString,'R')
        end;
    End;

  if AColumn = 7 then
    Begin
      if dgdbaPurchaseorder.FieldAtColumn[4].AsString = 'N' then
        begin
          CancelOrder(dgdbaPurchaseorder.FieldAtColumn[0].AsString);
        end;
    End;
end;


procedure TfrmOrderConfirmation.dgPurchaseOrdersGetCellDisplayValue(
  Sender: TObject; ACell: TTMSFNCDataGridCellCoord;
  AData: TTMSFNCDataGridCellValue; var AValue: string);
  var
    LAmount,
    NetBudget: Double;
     LCol, LRow: Integer;
begin
  LCol := ACell.Column;
  LRow := ACell.Row;
  GetBudget;
  if (LCol = 0) and (LRow >= dgPurchaseOrders.FixedRowCount) then
    begin
      If dgdbaJobcards.FieldAtColumn[4].AsFloat > -1 then
        begin
          NetBudget := wdsavailbudget.FieldByName('AvailableBudget').AsFloat - wdsJobCards.FieldByName('UserMax').AsFloat;
            if (dgdbaJobcards.FieldAtColumn[3].AsFloat <= NetBudget) and (NetBudget > 0) then
              Begin
                if (dgdbaJobcards.FieldAtColumn[3].AsFloat > dgdbaJobcards.FieldAtColumn[4].AsFloat) and (dgdbaPurchaseorder.FieldAtColumn[4].AsString <> 'Y') then
                  begin
                    AValue := '***'; // This overrides the display text
                  end;
              End;
        end
      else
        begin
          AValue := '***'; // This overrides the display text
        end;

    end;
end;

procedure TfrmOrderConfirmation.dgPurchaseOrdersGetCellLayout(Sender: TObject;
  ACell: TTMSFNCDataGridCell);

begin

  if ACell.Row < dgPurchaseOrders.FixedRowCount then
    Exit;

   // if ACell.Column = 0 then
  //      Begin
  //        dgdbaPurchaseorder.SetActiveRecord(ACell.Row);
  //
  //         if (dgdbaPurchaseorder.FieldAtColumn[4].AsString = 'N') OR (dgdbaPurchaseorder.FieldAtColumn[4].AsString = 'R') then
  //          begin
  //
  //                                                         OR (dgPurchaseOrders.StrippedCells[0,aCell.row] = 'R')
  //          end;
  //      End;
  if (dgPurchaseOrders.StrippedCells[0,aCell.row] = 'N') AND (ACell.Column = 0) then
     begin
      //ACell.Layout.Fill.Kind := gfkSolid;
      dgPurchaseOrders.Cells[0,aCell.row] := '';
     end;

  if dgPurchaseOrders.StrippedCells[4,aCell.row] = 'Y' then
     begin
      //ACell.Layout.Fill.Kind := gfkSolid;
      ACell.Layout.Fill.Color := gcGreen;
     end;

  if dgPurchaseOrders.StrippedCells[4,aCell.row] = 'N' then
    begin
      //ACell.Layout.Fill.Kind := gfkSolid;
      ACell.Layout.Fill.Color := gcYellow;
    end;

  if dgPurchaseOrders.StrippedCells[4,aCell.row] = 'R' then
    begin
      //ACell.Layout.Fill.Kind := gfkSolid;
      ACell.Layout.Fill.Color := gcRed;
    end;


end;

procedure TfrmOrderConfirmation.dgPurchaseOrdersGetCellProperties(
  Sender: TObject; ACell: TTMSFNCDataGridCell);
  var
    NetBudget: Double;
begin
  if ACell.IsBitmapCell and dgdbaPurchaseorder.IsValidDataCell(ACell.Coordinate) then
    begin
      GetBudget;
      if ACell.Column = 5 then
        Begin
          dgdbaPurchaseorder.SetActiveRecord(ACell.Row);
          If dgdbaJobcards.FieldAtColumn[4].AsFloat > -1 then
            begin
              NetBudget := wdsavailbudget.FieldByName('AvailableBudget').AsFloat - wdsJobCards.FieldByName('UserMax').AsFloat;
              If (dgdbaJobcards.FieldAtColumn[3].AsFloat <= NetBudget) and (NetBudget > 0) then
                begin
                  if (dgdbaJobcards.FieldAtColumn[3].AsFloat < dgdbaJobcards.FieldAtColumn[4].AsFloat) and (dgdbaPurchaseorder.FieldAtColumn[4].AsString = 'N') then
                   begin
                       ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[1]
                   end;
                end
              else
                begin
                  if dgdbaPurchaseorder.FieldAtColumn[4].AsString = 'N' then
                    begin
                      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[1]
                    end;
                end;

            End;
        end;

      if ACell.Column = 6 then
        Begin
          dgdbaPurchaseorder.SetActiveRecord(ACell.Row);
          If dgdbaJobcards.FieldAtColumn[4].AsFloat > -1 then
            begin
              NetBudget := wdsavailbudget.FieldByName('AvailableBudget').AsFloat - wdsJobCards.FieldByName('UserMax').AsFloat;
              If (dgdbaJobcards.FieldAtColumn[3].AsFloat <= NetBudget) and (NetBudget > 0) then
                begin
                  if (dgdbaJobcards.FieldAtColumn[3].AsFloat < dgdbaJobcards.FieldAtColumn[4].AsFloat) and (dgdbaPurchaseorder.FieldAtColumn[4].AsString = 'N') then
                    begin
                      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[0]
                    end;
                end;
            end
          else
            begin
              if dgdbaPurchaseorder.FieldAtColumn[4].AsString = 'N' then
               begin
                 ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[0]
               end;
            end;
        End;

      if ACell.Column = 7 then
        Begin
          dgdbaPurchaseorder.SetActiveRecord(ACell.Row);

          if (dgdbaPurchaseorder.FieldAtColumn[4].AsString <> '') then
            ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2];
        End;

      end;
end;


procedure TfrmOrderConfirmation.LoadJobcards;
var
  sJson,
  sDate : String;


  procedure OnError(Error: TXDataClientError);
    begin
      LoadJobcards;
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadJobcards;
        end
      else
        begin
          wdsJobCards.Close;
          wdsJobCards.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsJobCards.Open;
        end;
    end;


begin
  sDate := IntToStr((wYear * 100) + wMonth);
  sJson:= '{"Date" : "' + sDate  +  '","SLNCode":"'+ TAppSession.CurrentUser +'"}';
  wcJobcards.RawInvoke('IdashboardService.Get_JobcardPurchaseOrder_View',[sJson],@OnSuccess,@OnError);
end;


procedure TfrmOrderConfirmation.LoadPurchOrders;
var
  sJson : String;

  procedure OnError(Error: TXDataClientError);
    begin
      LoadPurchOrders;
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadPurchOrders;
        end
      else
        begin
          wdsPurchaseOrder.Close;
          wdsPurchaseOrder.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsPurchaseOrder.Open;
        end;
    end;

begin
  sJson:= '{"JOBCARDNO":"' + sJobCardNo + '"}';
  wcJobcards.RawInvoke('IdashboardService.Get_PurchaseOrders_View',[sJson],@OnSuccess,@OnError);
end;

Procedure TfrmOrderConfirmation.GetBudget;
var
  sJson : String;
  Data: TJSArray;
  procedure OnError(Error: TXDataClientError);
    begin
      GetBudget;
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          GetBudget;
        end
      else
        begin
          if Assigned(Response.Result) and TJSObject(Response.Result).hasOwnProperty('AvailableBudget') then
            begin
              Data := TJSArray([TJSObject(Response.Result)]);
              wdsAvailBudget.Close;
              wdsAvailBudget.SetJsonData(Data);
              wdsAvailBudget.Open;
            end;
        end;
    end;

begin
  sJson:= '{"JOBCARDNO":"' + '' + '"}';
  wcAvailBudget.RawInvoke('IdashboardService.AvailableMbudget',[sJson],@OnSuccess,@OnError);

end;

procedure TfrmOrderConfirmation.ApproveOrder(sOrderNo, sApprove: String);
var
  sJson : String;

  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          ShowMessage('Error aproving or rejecting purchase order');
        end
      else
        begin
          ShowMessage('Successfully approved or rejected');
          LoadPurchOrders;
        end;
    end;

begin
  sJson:= '{"approved":"' + sApprove + '","approvedby":"' + TAppSession.CurrentUser + '","ORDERNO":"' + sOrderNo + '"}';

  console.log(sJson);

  wcJobcards.RawInvoke('IdashboardService.Put_PurchaseOrder_Approve',[sJson],@OnSuccess,@OnError);
end;

procedure TfrmOrderConfirmation.btnNextMonthClick(Sender: TObject);
begin

  wMonth := wMonth + 1;
  if wMonth > 12 then
    begin
      wMonth := 1;
      wYear := wYear + 1;
    end;
  UpdateDateLabel;

  LoadJobcards;
end;


procedure TfrmOrderConfirmation.btnPrevMonthClick(Sender: TObject);
begin
 wMonth := wMonth - 1;
  if wMonth < 1 then
    begin
      wMonth := 12;
      wYear := wYear -1;
    end;
  UpdateDateLabel;
  LoadJobcards;
end;

procedure TfrmOrderConfirmation.UpdateDateLabel;
begin
  Case wMonth of
    1 : wlMonth.Caption := 'JANUARY ' + IntToStr(wYear);
    2 : wlMonth.Caption := 'FEBRUARY ' + IntToStr(wYear);
    3 : wlMonth.Caption := 'MARCH ' + IntToStr(wYear);
    4 : wlMonth.Caption := 'APRIL ' + IntToStr(wYear);
    5 : wlMonth.Caption := 'MAY ' + IntToStr(wYear);
    6 : wlMonth.Caption := 'JUNE ' + IntToStr(wYear);
    7 : wlMonth.Caption := 'JULY ' + IntToStr(wYear);
    8 : wlMonth.Caption := 'AUGUST ' + IntToStr(wYear);
    9 : wlMonth.Caption := 'SEPTEMBER ' + IntToStr(wYear);
    10 : wlMonth.Caption := 'OCTOBER ' + IntToStr(wYear);
    11 : wlMonth.Caption := 'NOVEMBER ' + IntToStr(wYear);
    12 : wlMonth.Caption := 'DECEMBER ' + IntToStr(wYear);
  End;
end;

procedure TfrmOrderConfirmation.CancelOrder(sOrderNo: String);
var
  sJson : String;

  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          ShowMessage('Error canceling purchase order');
        end
      else
        begin
          ShowMessage('Successfully Canceled');
          LoadPurchOrders;
        end;
    end;
begin
  sJson := '{"OrderNo":"'+sOrderNo+'","CanceledBy":"'+TAppSession.CurrentUser+'"}';

  wcPurchaseorder.RawInvoke('IdashboardService.Put_CancelPurchaseOrder',[sJson],@OnSuccess,@OnError);
end;

procedure TfrmOrderConfirmation.dgJobCardsCellClick(Sender: TObject;
  AColumn, ARow: Integer);
begin
  dgdbaJobcards.SetActiveRecord(ARow);
  //TJobDate := dgdbaJobcards.FieldAtColumn[0].AsDateTime;
  sJobCardNo := dgdbaJobcards.FieldAtColumn[1].AsString;
  //GetBudget;
  LoadPurchOrders;
end;

procedure TfrmOrderConfirmation.WebButton1Click(Sender: TObject);
begin
  LoadJobcards;
end;

procedure TfrmOrderConfirmation.WebFormResize(Sender: TObject);
begin
  pnlJobcards.Width := Round(Window.InnerWidth / 2.5)-12;
  pnlPurchaseOrders.Width := Round(Window.InnerWidth / 1.5)-13;
end;

procedure TfrmOrderConfirmation.WebFormShow(Sender: TObject);
begin
 DecodeDate(Now,wYear,wMonth,wDay);
 UpdateDateLabel;
 LoadJobcards;
end;

procedure TfrmOrderConfirmation.WebTimer1Timer(Sender: TObject);
begin
 DecodeDate(Now,wYear,wMonth,wDay);
 UpdateDateLabel;
 LoadJobcards;
end;

procedure TfrmOrderConfirmation.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  BitmapContainer1 := TTMSFNCBitmapContainer.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  wlMonth := TDBLabel.Create(Self);
  btnPrevMonth := TTMSFNCButton.Create(Self);
  btnNextMonth := TTMSFNCButton.Create(Self);
  pnlJobcards := TPanel.Create(Self);
  dgJobCards := TTMSFNCDataGrid.Create(Self);
  dgdbaJobcards := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  pnlPurchaseOrders := TPanel.Create(Self);
  dgPurchaseOrders := TTMSFNCDataGrid.Create(Self);
  dgdbaPurchaseorder := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  wcJobcards := TXDataWebClient.Create(Self);
  wdsJobCards := TXDataWebDataSet.Create(Self);
  wdsJobCardsJOBCARDNO := TStringField.Create(Self);
  wdsJobCardsTRUCKREGNO := TStringField.Create(Self);
  wdsJobCardsJobcardType := TStringField.Create(Self);
  wdsJobCardsTOTALCOSTEXCL := TFloatField.Create(Self);
  wdsJobCardsUserMax := TIntegerField.Create(Self);
  wdsJobCardsMBudget := TIntegerField.Create(Self);
  wdsJobCardsJobcardDate := TDateTimeField.Create(Self);
  dsJobcards := TDataSource.Create(Self);
  wcPurchaseorder := TXDataWebClient.Create(Self);
  wdsPurchaseOrder := TXDataWebDataSet.Create(Self);
  wdsPurchaseOrderORDERNO := TStringField.Create(Self);
  wdsPurchaseOrderTOTALCOSTEXCL := TFloatField.Create(Self);
  wdsPurchaseOrderSupplier := TStringField.Create(Self);
  wdsPurchaseOrderORDERDATE := TStringField.Create(Self);
  wdsPurchaseOrderapproved := TStringField.Create(Self);
  dsPurchaseOrder := TDataSource.Create(Self);
  WebTimer1 := TTimer.Create(Self);
  wcAvailBudget := TXDataWebClient.Create(Self);
  dsAvailBudget := TDataSource.Create(Self);
  wdsAvailBudget := TXDataWebDataSet.Create(Self);
  wdsAvailBudgetAvailableBudget := TFloatField.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  BitmapContainer1.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  wlMonth.BeforeLoadDFMValues;
  btnPrevMonth.BeforeLoadDFMValues;
  btnNextMonth.BeforeLoadDFMValues;
  pnlJobcards.BeforeLoadDFMValues;
  dgJobCards.BeforeLoadDFMValues;
  dgdbaJobcards.BeforeLoadDFMValues;
  pnlPurchaseOrders.BeforeLoadDFMValues;
  dgPurchaseOrders.BeforeLoadDFMValues;
  dgdbaPurchaseorder.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  wcJobcards.BeforeLoadDFMValues;
  wdsJobCards.BeforeLoadDFMValues;
  wdsJobCardsJOBCARDNO.BeforeLoadDFMValues;
  wdsJobCardsTRUCKREGNO.BeforeLoadDFMValues;
  wdsJobCardsJobcardType.BeforeLoadDFMValues;
  wdsJobCardsTOTALCOSTEXCL.BeforeLoadDFMValues;
  wdsJobCardsUserMax.BeforeLoadDFMValues;
  wdsJobCardsMBudget.BeforeLoadDFMValues;
  wdsJobCardsJobcardDate.BeforeLoadDFMValues;
  dsJobcards.BeforeLoadDFMValues;
  wcPurchaseorder.BeforeLoadDFMValues;
  wdsPurchaseOrder.BeforeLoadDFMValues;
  wdsPurchaseOrderORDERNO.BeforeLoadDFMValues;
  wdsPurchaseOrderTOTALCOSTEXCL.BeforeLoadDFMValues;
  wdsPurchaseOrderSupplier.BeforeLoadDFMValues;
  wdsPurchaseOrderORDERDATE.BeforeLoadDFMValues;
  wdsPurchaseOrderapproved.BeforeLoadDFMValues;
  dsPurchaseOrder.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  wcAvailBudget.BeforeLoadDFMValues;
  dsAvailBudget.BeforeLoadDFMValues;
  wdsAvailBudget.BeforeLoadDFMValues;
  wdsAvailBudgetAvailableBudget.BeforeLoadDFMValues;
  try
    Name := 'frmOrderConfirmation';
    Width := 1417;
    Height := 680;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1417;
    WebPanel1.Height := 680;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 1417;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Order Confirmation';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    BitmapContainer1.SetParentComponent(WebPanel2);
    BitmapContainer1.Name := 'BitmapContainer1';
    BitmapContainer1.Left := 1104;
    BitmapContainer1.Top := 16;
    BitmapContainer1.Width := 26;
    BitmapContainer1.Height := 26;
    BitmapContainer1.Visible := True;
    BitmapContainer1.Items.Clear;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('OrderConfirmation.BitmapContainer1.Items.Bitmap.svg');
      Name := 'cancel.svg';
      Tag := 0;
    end;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('OrderConfirmation.BitmapContainer1.Items.Bitmap_1.svg');
      Name := 'save.svg';
      Tag := 0;
    end;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('OrderConfirmation.BitmapContainer1.Items.Bitmap_2.svg');
      Name := 'clear.svg';
      Tag := 0;
    end;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 60;
    WebPanel3.Width := 1417;
    WebPanel3.Height := 61;
    WebPanel3.Align := alTop;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    wlMonth.SetParentComponent(WebPanel3);
    wlMonth.Name := 'wlMonth';
    wlMonth.Left := 76;
    wlMonth.Top := 12;
    wlMonth.Width := 184;
    wlMonth.Height := 15;
    wlMonth.Alignment := taCenter;
    wlMonth.AutoSize := False;
    wlMonth.Caption := 'Month';
    wlMonth.Color := clSilver;
    wlMonth.Font.Charset := DEFAULT_CHARSET;
    wlMonth.Font.Color := clBlack;
    wlMonth.Font.Height := -12;
    wlMonth.Font.Name := 'Segoe UI';
    wlMonth.Font.Style := [fsBold];
    wlMonth.HeightPercent := 100.000000000000000000;
    wlMonth.ParentFont := False;
    wlMonth.Transparent := False;
    wlMonth.WidthPercent := 100.000000000000000000;
    btnPrevMonth.SetParentComponent(WebPanel3);
    btnPrevMonth.Name := 'btnPrevMonth';
    btnPrevMonth.Left := 14;
    btnPrevMonth.Top := 6;
    btnPrevMonth.Width := 57;
    btnPrevMonth.Height := 25;
    btnPrevMonth.Font.Charset := DEFAULT_CHARSET;
    btnPrevMonth.Font.Color := clWindowText;
    btnPrevMonth.Font.Height := -12;
    btnPrevMonth.Font.Name := 'Segoe UI';
    btnPrevMonth.Font.Style := [fsBold];
    btnPrevMonth.Text := '<';
    btnPrevMonth.TabOrder := 0;
    SetEvent(btnPrevMonth, Self, 'OnClick', 'btnPrevMonthClick');
    btnNextMonth.SetParentComponent(WebPanel3);
    btnNextMonth.Name := 'btnNextMonth';
    btnNextMonth.Left := 275;
    btnNextMonth.Top := 6;
    btnNextMonth.Width := 57;
    btnNextMonth.Height := 25;
    btnNextMonth.Font.Charset := DEFAULT_CHARSET;
    btnNextMonth.Font.Color := clWindowText;
    btnNextMonth.Font.Height := -12;
    btnNextMonth.Font.Name := 'Segoe UI';
    btnNextMonth.Font.Style := [fsBold];
    btnNextMonth.Text := '>';
    btnNextMonth.TabOrder := 1;
    SetEvent(btnNextMonth, Self, 'OnClick', 'btnNextMonthClick');
    pnlJobcards.SetParentComponent(WebPanel1);
    pnlJobcards.Name := 'pnlJobcards';
    pnlJobcards.Left := 0;
    pnlJobcards.Top := 121;
    pnlJobcards.Width := 449;
    pnlJobcards.Height := 559;
    pnlJobcards.Align := alLeft;
    pnlJobcards.ChildOrder := 2;
    pnlJobcards.TabOrder := 2;
    dgJobCards.SetParentComponent(pnlJobcards);
    dgJobCards.Name := 'dgJobCards';
    dgJobCards.Left := 0;
    dgJobCards.Top := 0;
    dgJobCards.Width := 449;
    dgJobCards.Height := 559;
    dgJobCards.Align := alClient;
    dgJobCards.ParentDoubleBuffered := False;
    dgJobCards.DoubleBuffered := True;
    dgJobCards.TabOrder := 0;
    dgJobCards.ShowAcceleratorChar := False;
    dgJobCards.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgJobCards.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgJobCards.Header.VisualGrouping.Layout.Font.Height := -12;
    dgJobCards.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgJobCards.Header.VisualGrouping.Layout.Font.Style := [];
    dgJobCards.Adapter := dgdbaJobcards;
    dgJobCards.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgJobCards.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgJobCards.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgJobCards.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgJobCards.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgJobCards.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgJobCards.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgJobCards.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgJobCards.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgJobCards.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgJobCards.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgJobCards.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgJobCards.CellAppearance.BandLayout.Font.Height := -12;
    dgJobCards.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgJobCards.CellAppearance.BandLayout.Font.Style := [];
    dgJobCards.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgJobCards.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgJobCards.CellAppearance.FixedLayout.Font.Height := -12;
    dgJobCards.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgJobCards.CellAppearance.FixedLayout.Font.Style := [];
    dgJobCards.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgJobCards.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgJobCards.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgJobCards.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgJobCards.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgJobCards.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgJobCards.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgJobCards.CellAppearance.FocusedLayout.Font.Height := -12;
    dgJobCards.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgJobCards.CellAppearance.FocusedLayout.Font.Style := [];
    dgJobCards.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgJobCards.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgJobCards.CellAppearance.GroupLayout.Font.Height := -12;
    dgJobCards.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgJobCards.CellAppearance.GroupLayout.Font.Style := [];
    dgJobCards.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgJobCards.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgJobCards.CellAppearance.NormalLayout.Font.Height := -12;
    dgJobCards.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgJobCards.CellAppearance.NormalLayout.Font.Style := [];
    dgJobCards.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgJobCards.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgJobCards.CellAppearance.SelectedLayout.Font.Height := -12;
    dgJobCards.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgJobCards.CellAppearance.SelectedLayout.Font.Style := [];
    dgJobCards.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgJobCards.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgJobCards.CellAppearance.SummaryLayout.Font.Height := -12;
    dgJobCards.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgJobCards.CellAppearance.SummaryLayout.Font.Style := [];
    dgJobCards.ColumnCount := 7;
    dgJobCards.Columns.Clear;
    with dgJobCards.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'JobCard Date';
      Settings := [gcsEditorItems,gcsReadOnly];
    end;
    with dgJobCards.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Jobcard No';
      Settings := [gcsEditorItems,gcsReadOnly];
      Width := 100.000000000000000000;
    end;
    with dgJobCards.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Reg No';
      Settings := [gcsEditorItems,gcsReadOnly];
      Width := 150.000000000000000000;
    end;
    with dgJobCards.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems,gcsReadOnly];
      Width := 150.000000000000000000;
    end;
    with dgJobCards.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems,gcsReadOnly];
    end;
    with dgJobCards.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems,gcsReadOnly];
    end;
    with dgJobCards.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems,gcsReadOnly];
      Width := 150.000000000000000000;
    end;
    dgJobCards.Designer := False;
    dgJobCards.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgJobCards.FilterAppearance.Font.Color := clWindowText;
    dgJobCards.FilterAppearance.Font.Height := -12;
    dgJobCards.FilterAppearance.Font.Name := 'Segoe UI';
    dgJobCards.FilterAppearance.Font.Style := [];
    dgJobCards.Icons.ExpandIcon.LoadFromFile('OrderConfirmation.pnlJobcards.dgJobCards.Icons.ExpandIcon.svg');
    dgJobCards.Icons.CollapseIcon.LoadFromFile('OrderConfirmation.pnlJobcards.dgJobCards.Icons.CollapseIcon.svg');
    dgJobCards.Icons.FilterIcon.LoadFromFile('OrderConfirmation.pnlJobcards.dgJobCards.Icons.FilterIcon.svg');
    dgJobCards.Icons.FilterActiveIcon.LoadFromFile('OrderConfirmation.pnlJobcards.dgJobCards.Icons.FilterActiveIcon.svg');
    dgJobCards.Icons.FilterClearIcon.LoadFromFile('OrderConfirmation.pnlJobcards.dgJobCards.Icons.FilterClearIcon.svg');
    dgJobCards.Icons.FilterTypeIcon.LoadFromFile('OrderConfirmation.pnlJobcards.dgJobCards.Icons.FilterTypeIcon.svg');
    dgJobCards.Icons.SortAscendingIcon.LoadFromFile('OrderConfirmation.pnlJobcards.dgJobCards.Icons.SortAscendingIcon.svg');
    dgJobCards.Icons.SortDescendingIcon.LoadFromFile('OrderConfirmation.pnlJobcards.dgJobCards.Icons.SortDescendingIcon.svg');
    dgJobCards.Icons.CloseIcon.LoadFromFile('OrderConfirmation.pnlJobcards.dgJobCards.Icons.CloseIcon.svg');
    SetEvent(dgJobCards, Self, 'OnCellClick', 'dgJobCardsCellClick');
    dgJobCards.Options.Filtering.Enabled := True;
    dgJobCards.Options.Sorting.Enabled := True;
    dgJobCards.RowCount := 1;
    dgdbaJobcards.SetParentComponent(dgJobCards);
    dgdbaJobcards.Name := 'dgdbaJobcards';
    dgdbaJobcards.Left := 268;
    dgdbaJobcards.Top := 96;
    dgdbaJobcards.Width := 26;
    dgdbaJobcards.Height := 26;
    dgdbaJobcards.Visible := True;
    dgdbaJobcards.Columns.Clear;
    with dgdbaJobcards.Columns.Add do
    begin
      FieldName := 'JobcardDate';
      Header := 'JobCard Date';
      AutoCreated := False;
    end;
    with dgdbaJobcards.Columns.Add do
    begin
      FieldName := 'JOBCARDNO';
      Header := 'Jobcard No';
      AutoCreated := False;
    end;
    with dgdbaJobcards.Columns.Add do
    begin
      FieldName := 'TRUCKREGNO';
      Header := 'Reg No';
      AutoCreated := False;
    end;
    with dgdbaJobcards.Columns.Add do
    begin
      FieldName := 'TOTALCOSTEXCL';
      Header := 'Total Cost Excl';
      AutoCreated := False;
    end;
    with dgdbaJobcards.Columns.Add do
    begin
      FieldName := 'UserMax';
      AutoCreated := False;
    end;
    with dgdbaJobcards.Columns.Add do
    begin
      FieldName := 'MBudget';
      AutoCreated := False;
    end;
    with dgdbaJobcards.Columns.Add do
    begin
      FieldName := 'JobcardType';
      Header := 'Jobcard Type';
      AutoCreated := False;
    end;
    dgdbaJobcards.DataSource := dsJobcards;
    dgdbaJobcards.LoadMode := almAllRecords;
    pnlPurchaseOrders.SetParentComponent(WebPanel1);
    pnlPurchaseOrders.Name := 'pnlPurchaseOrders';
    pnlPurchaseOrders.Left := 474;
    pnlPurchaseOrders.Top := 121;
    pnlPurchaseOrders.Width := 871;
    pnlPurchaseOrders.Height := 559;
    pnlPurchaseOrders.Align := alLeft;
    pnlPurchaseOrders.ChildOrder := 3;
    pnlPurchaseOrders.TabOrder := 3;
    dgPurchaseOrders.SetParentComponent(pnlPurchaseOrders);
    dgPurchaseOrders.Name := 'dgPurchaseOrders';
    dgPurchaseOrders.Left := 0;
    dgPurchaseOrders.Top := 0;
    dgPurchaseOrders.Width := 871;
    dgPurchaseOrders.Height := 559;
    dgPurchaseOrders.Align := alClient;
    dgPurchaseOrders.ParentDoubleBuffered := False;
    dgPurchaseOrders.DoubleBuffered := True;
    dgPurchaseOrders.TabOrder := 0;
    dgPurchaseOrders.ShowAcceleratorChar := False;
    dgPurchaseOrders.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgPurchaseOrders.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgPurchaseOrders.Header.VisualGrouping.Layout.Font.Height := -12;
    dgPurchaseOrders.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgPurchaseOrders.Header.VisualGrouping.Layout.Font.Style := [];
    dgPurchaseOrders.Adapter := dgdbaPurchaseorder;
    dgPurchaseOrders.BitmapContainer := BitmapContainer1;
    dgPurchaseOrders.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgPurchaseOrders.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgPurchaseOrders.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgPurchaseOrders.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgPurchaseOrders.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgPurchaseOrders.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgPurchaseOrders.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgPurchaseOrders.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgPurchaseOrders.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgPurchaseOrders.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgPurchaseOrders.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgPurchaseOrders.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgPurchaseOrders.CellAppearance.BandLayout.Font.Height := -12;
    dgPurchaseOrders.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgPurchaseOrders.CellAppearance.BandLayout.Font.Style := [];
    dgPurchaseOrders.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgPurchaseOrders.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgPurchaseOrders.CellAppearance.FixedLayout.Font.Height := -12;
    dgPurchaseOrders.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgPurchaseOrders.CellAppearance.FixedLayout.Font.Style := [];
    dgPurchaseOrders.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgPurchaseOrders.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgPurchaseOrders.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgPurchaseOrders.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgPurchaseOrders.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgPurchaseOrders.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgPurchaseOrders.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgPurchaseOrders.CellAppearance.FocusedLayout.Font.Height := -12;
    dgPurchaseOrders.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgPurchaseOrders.CellAppearance.FocusedLayout.Font.Style := [];
    dgPurchaseOrders.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgPurchaseOrders.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgPurchaseOrders.CellAppearance.GroupLayout.Font.Height := -12;
    dgPurchaseOrders.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgPurchaseOrders.CellAppearance.GroupLayout.Font.Style := [];
    dgPurchaseOrders.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgPurchaseOrders.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgPurchaseOrders.CellAppearance.NormalLayout.Font.Height := -12;
    dgPurchaseOrders.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgPurchaseOrders.CellAppearance.NormalLayout.Font.Style := [];
    dgPurchaseOrders.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgPurchaseOrders.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgPurchaseOrders.CellAppearance.SelectedLayout.Font.Height := -12;
    dgPurchaseOrders.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgPurchaseOrders.CellAppearance.SelectedLayout.Font.Style := [];
    dgPurchaseOrders.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgPurchaseOrders.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgPurchaseOrders.CellAppearance.SummaryLayout.Font.Height := -12;
    dgPurchaseOrders.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgPurchaseOrders.CellAppearance.SummaryLayout.Font.Style := [];
    dgPurchaseOrders.ColumnCount := 8;
    dgPurchaseOrders.Columns.Clear;
    with dgPurchaseOrders.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'OrderNo';
      Settings := [gcsReadOnly];
    end;
    with dgPurchaseOrders.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Order Date';
      Settings := [gcsReadOnly];
      Width := 150.000000000000000000;
    end;
    with dgPurchaseOrders.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Supplier';
      Settings := [gcsReadOnly];
      Width := 200.000000000000000000;
    end;
    with dgPurchaseOrders.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.NormalLayout.TextAlign := gtaTrailing;
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Formatting.&Type := gdftFloat;
      Formatting.Format := '#,##0.00';
      Header := 'Total Cost Excl';
      Settings := [gcsAppearance,gcsReadOnly,gcsFormatting];
      Width := 125.000000000000000000;
    end;
    with dgPurchaseOrders.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Approved';
      Settings := [gcsReadOnly];
    end;
    with dgPurchaseOrders.Columns.Add do
    begin
      ReadOnly := True;
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Approve';
      Settings := [gcsType,gcsReadOnly];
    end;
    with dgPurchaseOrders.Columns.Add do
    begin
      ReadOnly := True;
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Reject';
      Settings := [gcsType,gcsReadOnly];
    end;
    with dgPurchaseOrders.Columns.Add do
    begin
      ReadOnly := True;
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Cancel';
      Settings := [gcsType,gcsReadOnly];
    end;
    dgPurchaseOrders.Designer := False;
    dgPurchaseOrders.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgPurchaseOrders.FilterAppearance.Font.Color := clWindowText;
    dgPurchaseOrders.FilterAppearance.Font.Height := -12;
    dgPurchaseOrders.FilterAppearance.Font.Name := 'Segoe UI';
    dgPurchaseOrders.FilterAppearance.Font.Style := [];
    dgPurchaseOrders.Icons.ExpandIcon.LoadFromFile('OrderConfirmation.pnlPurchaseOrders.dgPurchaseOrders.Icons.ExpandIcon.svg');
    dgPurchaseOrders.Icons.CollapseIcon.LoadFromFile('OrderConfirmation.pnlPurchaseOrders.dgPurchaseOrders.Icons.CollapseIcon.svg');
    dgPurchaseOrders.Icons.FilterIcon.LoadFromFile('OrderConfirmation.pnlPurchaseOrders.dgPurchaseOrders.Icons.FilterIcon.svg');
    dgPurchaseOrders.Icons.FilterActiveIcon.LoadFromFile('OrderConfirmation.pnlPurchaseOrders.dgPurchaseOrders.Icons.FilterActiveIcon.svg');
    dgPurchaseOrders.Icons.FilterClearIcon.LoadFromFile('OrderConfirmation.pnlPurchaseOrders.dgPurchaseOrders.Icons.FilterClearIcon.svg');
    dgPurchaseOrders.Icons.FilterTypeIcon.LoadFromFile('OrderConfirmation.pnlPurchaseOrders.dgPurchaseOrders.Icons.FilterTypeIcon.svg');
    dgPurchaseOrders.Icons.SortAscendingIcon.LoadFromFile('OrderConfirmation.pnlPurchaseOrders.dgPurchaseOrders.Icons.SortAscendingIcon.svg');
    dgPurchaseOrders.Icons.SortDescendingIcon.LoadFromFile('OrderConfirmation.pnlPurchaseOrders.dgPurchaseOrders.Icons.SortDescendingIcon.svg');
    dgPurchaseOrders.Icons.CloseIcon.LoadFromFile('OrderConfirmation.pnlPurchaseOrders.dgPurchaseOrders.Icons.CloseIcon.svg');
    SetEvent(dgPurchaseOrders, Self, 'OnCellClick', 'dgPurchaseOrdersCellClick');
    SetEvent(dgPurchaseOrders, Self, 'OnGetCellDisplayValue', 'dgPurchaseOrdersGetCellDisplayValue');
    SetEvent(dgPurchaseOrders, Self, 'OnGetCellLayout', 'dgPurchaseOrdersGetCellLayout');
    SetEvent(dgPurchaseOrders, Self, 'OnGetCellProperties', 'dgPurchaseOrdersGetCellProperties');
    dgPurchaseOrders.Options.Filtering.Enabled := True;
    dgPurchaseOrders.Options.Sorting.Enabled := True;
    dgPurchaseOrders.RowCount := 1;
    dgdbaPurchaseorder.SetParentComponent(dgPurchaseOrders);
    dgdbaPurchaseorder.Name := 'dgdbaPurchaseorder';
    dgdbaPurchaseorder.Left := 312;
    dgdbaPurchaseorder.Top := 176;
    dgdbaPurchaseorder.Width := 26;
    dgdbaPurchaseorder.Height := 26;
    dgdbaPurchaseorder.Visible := True;
    dgdbaPurchaseorder.Columns.Clear;
    with dgdbaPurchaseorder.Columns.Add do
    begin
      FieldName := 'ORDERNO';
      Header := 'OrderNo';
      AutoCreated := False;
    end;
    with dgdbaPurchaseorder.Columns.Add do
    begin
      FieldName := 'ORDERDATE';
      Header := 'Order Date';
      AutoCreated := False;
    end;
    with dgdbaPurchaseorder.Columns.Add do
    begin
      FieldName := 'Supplier';
      Header := 'Supplier';
      AutoCreated := False;
    end;
    with dgdbaPurchaseorder.Columns.Add do
    begin
      FieldName := 'TOTALCOSTEXCL';
      Header := 'Total Cost Excl';
      AutoCreated := False;
    end;
    with dgdbaPurchaseorder.Columns.Add do
    begin
      FieldName := 'approved';
      Header := 'Approved';
      AutoCreated := False;
    end;
    with dgdbaPurchaseorder.Columns.Add do
    begin
      Header := 'Approve';
      AutoCreated := False;
    end;
    with dgdbaPurchaseorder.Columns.Add do
    begin
      Header := 'Reject';
      AutoCreated := False;
    end;
    with dgdbaPurchaseorder.Columns.Add do
    begin
      Header := 'Cancel';
      AutoCreated := False;
    end;
    dgdbaPurchaseorder.DataSource := dsPurchaseOrder;
    dgdbaPurchaseorder.LoadMode := almAllRecords;
    WebPanel4.SetParentComponent(WebPanel1);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 449;
    WebPanel4.Top := 121;
    WebPanel4.Width := 25;
    WebPanel4.Height := 559;
    WebPanel4.Align := alLeft;
    WebPanel4.ChildOrder := 4;
    WebPanel4.Color := clSilver;
    WebPanel4.TabOrder := 4;
    wcJobcards.SetParentComponent(Self);
    wcJobcards.Name := 'wcJobcards';
    wcJobcards.Connection := dmData.dbConnect;
    wcJobcards.Left := 48;
    wcJobcards.Top := 220;
    wdsJobCards.SetParentComponent(Self);
    wdsJobCards.Name := 'wdsJobCards';
    wdsJobCards.Connection := dmData.dbConnect;
    wdsJobCards.Left := 120;
    wdsJobCards.Top := 220;
    wdsJobCardsJOBCARDNO.SetParentComponent(wdsJobCards);
    wdsJobCardsJOBCARDNO.Name := 'wdsJobCardsJOBCARDNO';
    wdsJobCardsJOBCARDNO.FieldName := 'JOBCARDNO';
    wdsJobCardsTRUCKREGNO.SetParentComponent(wdsJobCards);
    wdsJobCardsTRUCKREGNO.Name := 'wdsJobCardsTRUCKREGNO';
    wdsJobCardsTRUCKREGNO.FieldName := 'TRUCKREGNO';
    wdsJobCardsJobcardType.SetParentComponent(wdsJobCards);
    wdsJobCardsJobcardType.Name := 'wdsJobCardsJobcardType';
    wdsJobCardsJobcardType.FieldName := 'JobcardType';
    wdsJobCardsTOTALCOSTEXCL.SetParentComponent(wdsJobCards);
    wdsJobCardsTOTALCOSTEXCL.Name := 'wdsJobCardsTOTALCOSTEXCL';
    wdsJobCardsTOTALCOSTEXCL.FieldName := 'TOTALCOSTEXCL';
    wdsJobCardsTOTALCOSTEXCL.DisplayFormat := '#,##0.00';
    wdsJobCardsUserMax.SetParentComponent(wdsJobCards);
    wdsJobCardsUserMax.Name := 'wdsJobCardsUserMax';
    wdsJobCardsUserMax.FieldName := 'UserMax';
    wdsJobCardsMBudget.SetParentComponent(wdsJobCards);
    wdsJobCardsMBudget.Name := 'wdsJobCardsMBudget';
    wdsJobCardsMBudget.FieldName := 'MBudget';
    wdsJobCardsJobcardDate.SetParentComponent(wdsJobCards);
    wdsJobCardsJobcardDate.Name := 'wdsJobCardsJobcardDate';
    wdsJobCardsJobcardDate.FieldName := 'JobcardDate';
    dsJobcards.SetParentComponent(Self);
    dsJobcards.Name := 'dsJobcards';
    dsJobcards.DataSet := wdsJobCards;
    dsJobcards.Left := 200;
    dsJobcards.Top := 216;
    wcPurchaseorder.SetParentComponent(Self);
    wcPurchaseorder.Name := 'wcPurchaseorder';
    wcPurchaseorder.Connection := dmData.dbConnect;
    wcPurchaseorder.Left := 538;
    wcPurchaseorder.Top := 297;
    wdsPurchaseOrder.SetParentComponent(Self);
    wdsPurchaseOrder.Name := 'wdsPurchaseOrder';
    wdsPurchaseOrder.Connection := dmData.dbConnect;
    wdsPurchaseOrder.Left := 610;
    wdsPurchaseOrder.Top := 297;
    wdsPurchaseOrderORDERNO.SetParentComponent(wdsPurchaseOrder);
    wdsPurchaseOrderORDERNO.Name := 'wdsPurchaseOrderORDERNO';
    wdsPurchaseOrderORDERNO.FieldName := 'ORDERNO';
    wdsPurchaseOrderORDERNO.ReadOnly := True;
    wdsPurchaseOrderTOTALCOSTEXCL.SetParentComponent(wdsPurchaseOrder);
    wdsPurchaseOrderTOTALCOSTEXCL.Name := 'wdsPurchaseOrderTOTALCOSTEXCL';
    wdsPurchaseOrderTOTALCOSTEXCL.FieldName := 'TOTALCOSTEXCL';
    wdsPurchaseOrderTOTALCOSTEXCL.DisplayFormat := '#,##0.00';
    wdsPurchaseOrderSupplier.SetParentComponent(wdsPurchaseOrder);
    wdsPurchaseOrderSupplier.Name := 'wdsPurchaseOrderSupplier';
    wdsPurchaseOrderSupplier.FieldName := 'Supplier';
    wdsPurchaseOrderORDERDATE.SetParentComponent(wdsPurchaseOrder);
    wdsPurchaseOrderORDERDATE.Name := 'wdsPurchaseOrderORDERDATE';
    wdsPurchaseOrderORDERDATE.FieldName := 'ORDERDATE';
    wdsPurchaseOrderapproved.SetParentComponent(wdsPurchaseOrder);
    wdsPurchaseOrderapproved.Name := 'wdsPurchaseOrderapproved';
    wdsPurchaseOrderapproved.FieldName := 'approved';
    dsPurchaseOrder.SetParentComponent(Self);
    dsPurchaseOrder.Name := 'dsPurchaseOrder';
    dsPurchaseOrder.DataSet := wdsPurchaseOrder;
    dsPurchaseOrder.Left := 704;
    dsPurchaseOrder.Top := 296;
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Interval := 300000;
    SetEvent(WebTimer1, Self, 'OnTimer', 'WebTimer1Timer');
    WebTimer1.Left := 848;
    WebTimer1.Top := 16;
    wcAvailBudget.SetParentComponent(Self);
    wcAvailBudget.Name := 'wcAvailBudget';
    wcAvailBudget.Connection := dmData.dbConnect;
    wcAvailBudget.Left := 538;
    wcAvailBudget.Top := 185;
    dsAvailBudget.SetParentComponent(Self);
    dsAvailBudget.Name := 'dsAvailBudget';
    dsAvailBudget.DataSet := wdsAvailBudget;
    dsAvailBudget.Left := 744;
    dsAvailBudget.Top := 184;
    wdsAvailBudget.SetParentComponent(Self);
    wdsAvailBudget.Name := 'wdsAvailBudget';
    wdsAvailBudget.Connection := dmData.dbConnect;
    wdsAvailBudget.Left := 650;
    wdsAvailBudget.Top := 217;
    wdsAvailBudgetAvailableBudget.SetParentComponent(wdsAvailBudget);
    wdsAvailBudgetAvailableBudget.Name := 'wdsAvailBudgetAvailableBudget';
    wdsAvailBudgetAvailableBudget.FieldName := 'AvailableBudget';
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    BitmapContainer1.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    wlMonth.AfterLoadDFMValues;
    btnPrevMonth.AfterLoadDFMValues;
    btnNextMonth.AfterLoadDFMValues;
    pnlJobcards.AfterLoadDFMValues;
    dgJobCards.AfterLoadDFMValues;
    dgdbaJobcards.AfterLoadDFMValues;
    pnlPurchaseOrders.AfterLoadDFMValues;
    dgPurchaseOrders.AfterLoadDFMValues;
    dgdbaPurchaseorder.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    wcJobcards.AfterLoadDFMValues;
    wdsJobCards.AfterLoadDFMValues;
    wdsJobCardsJOBCARDNO.AfterLoadDFMValues;
    wdsJobCardsTRUCKREGNO.AfterLoadDFMValues;
    wdsJobCardsJobcardType.AfterLoadDFMValues;
    wdsJobCardsTOTALCOSTEXCL.AfterLoadDFMValues;
    wdsJobCardsUserMax.AfterLoadDFMValues;
    wdsJobCardsMBudget.AfterLoadDFMValues;
    wdsJobCardsJobcardDate.AfterLoadDFMValues;
    dsJobcards.AfterLoadDFMValues;
    wcPurchaseorder.AfterLoadDFMValues;
    wdsPurchaseOrder.AfterLoadDFMValues;
    wdsPurchaseOrderORDERNO.AfterLoadDFMValues;
    wdsPurchaseOrderTOTALCOSTEXCL.AfterLoadDFMValues;
    wdsPurchaseOrderSupplier.AfterLoadDFMValues;
    wdsPurchaseOrderORDERDATE.AfterLoadDFMValues;
    wdsPurchaseOrderapproved.AfterLoadDFMValues;
    dsPurchaseOrder.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
    wcAvailBudget.AfterLoadDFMValues;
    dsAvailBudget.AfterLoadDFMValues;
    wdsAvailBudget.AfterLoadDFMValues;
    wdsAvailBudgetAvailableBudget.AfterLoadDFMValues;
  end;
end;

end.
